import { get } from './index';

export const getAdminStats = () => get('/api/v1/admin/stats').then((res) => res.json());
